export default __webpack_public_path__ + "f17b1b2f94c8578604a612b1d5717ebf.svg";